import React from 'react';

const LoadingSpinner: React.FC = () => (
  <div className="d-flex justify-content-center align-items-center py-5">
    <div className="spinner-border text-warning" role="status" aria-label="Loading">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

export default LoadingSpinner;
